<div class="custom-component-theme c-body">
    <div class="c-header">

        <button (click)="close()" class="close-btn">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="c-blue-container">
        
        <div class="c-phone-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path
                    d="M19.23 15.7598L16.69 15.4698C16.08 15.3998 15.48 15.6098 15.05 16.0398L13.21 17.8798C10.38 16.4398 8.06004 14.1298 6.62004 11.2898L8.47004 9.43976C8.90004 9.00977 9.11004 8.40977 9.04004 7.79977L8.75004 5.27977C8.63004 4.26977 7.78004 3.50977 6.76004 3.50977H5.03004C3.90004 3.50977 2.96004 4.44977 3.03004 5.57977C3.56004 14.1198 10.39 20.9398 18.92 21.4698C20.05 21.5398 20.99 20.5998 20.99 19.4698V17.7398C21 16.7298 20.24 15.8798 19.23 15.7598Z"
                    fill="white" />
            </svg>
        </div>

        <div class="f-col">
            <span class="c-title">For Tier 2, call AAU</span>
            <a href="tel:4079347200"> <span class="c-phone">407-934-7200</span></a>
        </div>

    </div>
</div>